mutation PaymentRowProtection($input: PaymentRowProtectionInput!) {
  paymentRowProtection(input: $input) {
    secureRowLevel {
      id
      name
    }
  }
}
